<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="applications"
                    :loading="tableloading"
                    loading-text="Calling bookmark data..."
                    sort-desc="true"
                    :items-per-page="5"
                    style="font-size: small;"
                >
                    <template v-slot:item.view="{ item }">
                        <v-icon
                            class="mr-2"
                            @click="viewApplication(item)"
                            v-if="item.name != 'Deleted Application'"
                        >
                            mdi-eye
                        </v-icon>
                    </template>
                    <template v-slot:item.unbookmark="{ item }">
                        <v-btn icon small @click="unBookmarkApplication(item)" :loading="loadingunbookmark"><v-icon>mdi-bookmark-off</v-icon></v-btn>
                    </template>
                    <template v-slot:no-data>
                        <v-container style="height: 100px;">
                            <v-row
                                class="fill-height"
                                align-content="center"
                                justify="center"
                            >
                                <v-col
                                    class="text-subtitle-1 text-center"
                                    cols="12"
                                >
                                    No Bookmarked application
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog
            v-model="dialog"
            fullscreen
            persistent
        >
            <v-card elevation="0">
                <v-toolbar color="#7CB342" dark>
                    <v-toolbar-title>View Application</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeView">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar>
                <ViewDetails :item="selectedApplication" v-if="dialog"/>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewDetails from "./ViewDetails.vue"
export default {
    components: {
        ViewDetails,
    },
    data(){
        return {
            host: location.hostname.toString(),
            bookmarkList: [],
            tableloading: false,
            search: '',
            headers: [
                { text: 'Name', value: 'name'},
                { text: 'Term', value: 'term' },
                { text: 'Subject', value: 'discipline' },
                { text: 'Posting Title', value: 'postingtitle' },
                { text: 'type', value: 'postingtype' },
                { text: 'Course(s)', value: 'coursesText'},
                { text: 'Submitted', value: 'submittedtime' },
                { text: 'View', value: 'view', sortable: false },
                { text: '', value: 'unbookmark', sortable: false },
            ],
            applications: [],
            selectedApplication: {},
            dialog: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            loadingunbookmark: false
        }
    },
    methods: {
        getBookmark(){
            const that = this;
            that.tableloading = true;
            that.applications = [];

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getbookmarks';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            if(json.data[0].hasOwnProperty("bookmarks")){
                                that.modifyData(json.data[0].bookmarks);
                            }
                        }
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }

                    that.tableloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        modifyData(item){
            const that = this;
            var list = [];
            item.forEach(element => {
                if(JSON.stringify(element["application"]) == "{}"){
                    let record = {};
                    record["bookmarkid"] = element["_itemid"];
                    record["name"] = "Deleted Application";
                    that.applications.push(record);
                } else {
                    let record = {};
                    record["inbookmark"] = true;
                    record["bookmarkid"] = element["_itemid"];
                    record["applicationid"] = element["application"]["id"];
                    record["uid"] = element["application"]["uid"];
                    record["discipline"] = element["application"]["discipline"];
                    record["posting"] = element["posting"];
                    record["cupeposition"] = element["application"]["cupeposition"];
                    record["legaltowork"] = element["application"]["legaltowork"];
                    record["generalinfo"] = element["application"]["generalinfo"];
                    record["employment"] = element["application"]["employment"];
                    record["education"] = element["application"]["education"];
                    record["references"] = element["application"]["references"];
                    record["fileCV"] = element["application"]["fileCV"];
                    if(element.hasOwnProperty("suppletype1")){
                        record["filesupple1"] = element["filesupple1"];
                        record["suppletype1"] = element["suppletype1"];
                    }
                    if(element.hasOwnProperty("suppletype2")){
                        record["filesupple2"] = element["filesupple2"];
                        record["suppletype2"] = element["suppletype2"];
                    }
                    record["submittedTimestamp"] = element["application"]["submittedTimestamp"];
                    record["submitYear"] = element["application"]["submitYear"];
                
                    record["name"] = element["application"]["generalinfo"]["firstname"]+" "+element["application"]["generalinfo"]["lastname"];
                    record["submittedtime"] = that.convertTime(element["application"]["submittedTimestamp"]);
                    record["term"] = that.resolveTerm(element["posting"]["strm"]);
                    record["postingtitle"] = element["posting"]["title"];
                    record["postingid"] = element["posting"]["id"];
                    record["postingtype"] = element["posting"]["type"];
                    //Courses
                    var courselist = "";
                    element["posting"]["courses"].forEach(e => {
                        if(e["ssrcomponent"] == "LEC"){
                            courselist += e["catalognbr"]+", ";
                        }
                    });
                    record["coursesText"] = courselist.slice(0,-2);

                    if(element["application"].hasOwnProperty("admin")){
                        if(element["application"]["admin"].hasOwnProperty("adoFlag")){
                            record["adoFlag"] = parseInt(element["application"]["admin"]["adoFlag"]["value"]);
                        }else {
                            record["adoFlag"] = 0;
                        }

                        if(element["application"]["admin"].hasOwnProperty("seniorityPoints")){
                            record["seniorityPoints"] = element["application"]["admin"]["seniorityPoints"]["value"];
                        }else {
                            record["seniorityPoints"] = "";
                        }

                        if(element["application"]["admin"].hasOwnProperty("justifications")){
                            var justifications = [];
                            element["application"]["admin"]["justifications"].forEach(comments => {
                                if(courselist.slice(0,-2) == comments["course"]){
                                    justifications.push({
                                        "comment": comments["comment"],
                                        "madeby": comments["updatedByCommonName"],
                                        "madeon": comments["updatedDateTime"].split(".")[0]
                                    })
                                }
                            });

                            record["justifications"] = justifications;
                        }else {
                            record["justifications"] = [];
                        }

                        if(element["application"]["admin"].hasOwnProperty("managerComments")){
                            var managercomments = [];
                            element["application"]["admin"]["managerComments"].forEach(comm => {
                                if(courselist.slice(0,-2) == comm["course"]){
                                    managercomments.push({
                                        "comment": comm["comment"],
                                        "madeby": comm["updatedByCommonName"],
                                        "madeon": comm["updatedDateTime"].split(".")[0]
                                    })
                                }
                            });

                            record["managercomments"] = managercomments;
                        }else {
                            record["managercomments"] = [];
                        }
                    }else {
                        record["justifications"] = [];
                        record["managercomments"] = [];
                    }

                    list.push(record);
                }
            });
            
            that.applications.push(...list);
        },
        convertTime(time){
            let date = new Date(parseFloat(time));

            return date.toDateString()+", "+String(date.getHours()).padStart(2, '0')+":"+String(date.getMinutes()).padStart(2, '0')+":"+String(date.getSeconds()).padStart(2, '0');
        },
        resolveTerm(stream){
            const that = this;
            let term = stream.slice(-1);
            var year = stream[1]+stream[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(stream[0])-1).toString();
            if(term == "9"){
                return "FALL 2"+century+year+"/WINTER 2"+century+year2;
            }else if(term == "5"){
                return "SUMMER 2"+century+year;
            }
        },
        unBookmarkApplication(item){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=deleteBookmark&data={"id": "'+item.bookmarkid+'"}';

            that.loadingunbookmark = true;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.setSnackbar("Successfully removed from the bookmark", "#81B622"); //green
                        that.getBookmark();
                    }else {
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }

                    that.loadingunbookmark = false;
                })
                .catch(function () {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.loadingunbookmark = false;
                })
        },
        viewApplication(item){
            const that = this;
            that.selectedApplication = item;
            that.dialog = true;
        },
        closeView(){
            const that= this;

            that.dialog = false;
            that.getBookmark();
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getBookmark();
    }
}
</script>